// Cross-host accessibility props.
//
// react-native-web does NOT forward `accessibilityState` — it is absent from
// its `forwardedProps` list, and the only thing in the library that reads a
// state is `AccessibilityUtil/isDisabled.js`, which looks at
// `accessibilityStateS` (plural, an older API) and is imported only by the
// legacy `Touchable`, never by `Pressable`. So on web that prop is inert, not
// degraded. `aria-*` IS forwarded, and RN maps `aria-*` natively too
// (`View.js`: `busy: ariaBusy ?? accessibilityState?.busy`), which makes it the
// one prop that reaches both hosts.
//
// 📖 Full census of what RNW keeps and drops: `next/rnw-strangler.md §4.1`.

/**
 * `aria-busy` for a control whose content is swapped for a spinner while work
 * is in flight (RW-38).
 *
 * ⛔ Emitted ONLY when true. `aria-busy="false"` is the spec default, so
 * spelling it out on every control in the app would be noise on a state that is
 * the default everywhere.
 *
 * ⚠️ This carries the MACHINE-READABLE half only. No mainstream screen reader
 * spontaneously announces `aria-busy` on a `role="button"` — a user who moved
 * focus away after tapping hears nothing. The perceivable half is WCAG 4.1.3
 * Status Messages and needs a live region (`accessibilityLiveRegion`, as
 * `EditorTopBar.tsx` does). That is still open: RW-38.
 */
export const busyAria = (loading: boolean | undefined): { "aria-busy"?: true } =>
  loading ? { "aria-busy": true } : {};
